import { createAsyncAction, createAction } from 'typesafe-actions';
import { IdType, ListResult } from '@rootCommon/types/common';
import { Filters } from '@rootCommon/types/filter';
import { UserGroup, UserGroupDto, UserGroupListItem } from '@rootCommon/types/user-group';

// item
export const fetchUserGroup = createAsyncAction(
  'FETCH_USER_GROUP_REQUEST',
  'FETCH_USER_GROUP_SUCCESS',
  'FETCH_USER_GROUP_FAILURE',
)<IdType, UserGroup, Error>();

export const createUserGroup = createAsyncAction(
  'CREATE_USER_GROUP_REQUEST',
  'CREATE_USER_GROUP_SUCCESS',
  'CREATE_USER_GROUP_FAILURE',
)<UserGroupDto, UserGroup, Error>();

export const createUserGroupModal = createAsyncAction(
  'CREATE_USER_GROUP_MODAL_REQUEST',
  'CREATE_USER_GROUP_MODAL_SUCCESS',
  'CREATE_USER_GROUP_MODAL_FAILURE',
)<UserGroupDto, UserGroup, Error>();

export const updateUserGroup = createAsyncAction(
  'UPDATE_USER_GROUP_REQUEST',
  'UPDATE_USER_GROUP_SUCCESS',
  'UPDATE_USER_GROUP_FAILURE',
)<{ id: IdType; data: UserGroupDto }, UserGroup, Error>();

export const deleteUserGroup = createAsyncAction(
  'DELETE_USER_GROUP_REQUEST',
  'DELETE_USER_GROUP_SUCCESS',
  'DELETE_USER_GROUP_FAILURE',
)<IdType, IdType, Error>();

// list
export const fetchUserGroups = createAsyncAction(
  'FETCH_USER_GROUPS_REQUEST',
  'FETCH_USER_GROUPS_SUCCESS',
  'FETCH_USER_GROUPS_FAILURE',
)<void, ListResult<UserGroupListItem>, Error>();

export const setUserGroupsFilter = createAction('SET_USER_GROUPS_FILTER')<Filters>();
export const setCreatedUserGroupId = createAction('SET_CREATED_USER_GROUP_ID')<IdType | null>();
